<template>
    <v-card class="card-post">

        <router-link :to="'/blog/' + post.slug">
            <v-img :src="getPathFromMedia + post.image.url" height="307px"></v-img>
        </router-link>

        <v-flex class="card-text-wrap">
            <v-card-text class="pt-8 pb-4 px-8">
                <router-link :to="'/blog/' + post.slug">
                    <h2 class="text--primary mb-5">{{ post.title }}</h2>
                </router-link>
                <p>{{ post.excerpt }}</p>
                <v-spacer></v-spacer>
            </v-card-text>

            <v-card-actions class="px-8 pt-0 pb-8">
                <v-btn text class="read-more" :to="'/blog/' + post.slug">Read More</v-btn>
            </v-card-actions>
        </v-flex>
    </v-card>
</template>

<script>

export default {
    props: ['post'],
    data() {
        return {
            getPathFromMedia: process.env.VUE_APP_CMS_BASE_URL ?? 'https://cms.edurent.com'
        }
    }
};
</script>

<style scoped>
    .card-text-wrap p {
        font-size: 16px;
        line-height: 1.5;
    }
</style>